import React, { useState, useEffect } from "react";
import EmGptChatBox from "../ProductDashboard/Emgpt/EmgptChatBox";
import DocAssistantFilterBar from "../Common/DocAssistantFilterBar";
import {
  fetchDocumentIdWithTags,
  fetchDocumentIdsWithDataSource,
  retrivePdfUrl,
  retriveRelevantImages,
} from "../../utilities/DocAssistantUtilities";
import RelevantSection from "./RelevantSection";
import { formatLabel } from "../../utilities/CommonUtilities";
import { useLocation } from "react-router-dom";
import { Helmet } from "react-helmet";

function DocAssistant() {

  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const documment_type = params.get("document_type");
  const [pageNumbers, setPageNumbers] = useState([]);
  const [imageUrls, setImageUrls] = useState([]);
  const [pdfUrl, setPdfUrl] = useState(null);
  const [inUseDocumentIds, setInUseDocumentIds] = useState([]);
  const [documentIds, setDocumentIds] = useState([]);
  const [title, setTitle] = useState("");
  const [selectedDocumentType, setSelectedDocumentType] = useState(null);
  const [chatSuggestions, setChatSuggestion] = useState([
    "Summarize the Document based on the selected filters.",
    "Summarize the GDP Growth for the selected year and country.",
    "What are the challenges and progress mentioned in the Document?",
  ]);
  const [message, setMessage] = useState(
    "Please select filters to view documents"
  );
  const [selectedFilters, setSelectedFilters] = useState({
    country: null,
    documentType: null,
    year: new Date().getFullYear(),
  });

  useEffect(() => {
    if (
      selectedFilters.country != null &&
      selectedFilters.year != null &&
      selectedDocumentType != null
    ) {
      fetchDocumentIdWithTags(selectedDocumentType.value,selectedFilters, setInUseDocumentIds, setMessage);
    }
  }, [selectedFilters]);

  useEffect(() => {
    if (selectedDocumentType != null) {
      fetchDocumentIdsWithDataSource(selectedDocumentType, setDocumentIds);
    }
  }, [selectedDocumentType]);
  useEffect(() => {
    if (documment_type != null) {
      setSelectedDocumentType({ value: documment_type, label: documment_type });
    }
  },[])

  useEffect(() => {
    retriveRelevantImages(pageNumbers, inUseDocumentIds, setImageUrls);
  }, [pageNumbers]);

  const getHeight = () => {
    const div = document.getElementById("component_section");
    const height = div?.clientHeight;
    return height;
  };

  useEffect(() => {
    const fileName = inUseDocumentIds[0]
      ? inUseDocumentIds[0]["document_name"]
      : "";
    const title = formatLabel(fileName.split(".")[0]);
    setTitle(title);
    retrivePdfUrl(inUseDocumentIds, setPdfUrl);
  }, [inUseDocumentIds]);

  return (
    <>
      <Helmet>
        <title>Report Reader | EMAlpha</title>
      </Helmet>
      <div className="d-flex " style={{ height: "8%" }}>
        <DocAssistantFilterBar
          setSelectedFilters={setSelectedFilters}
          selectedDocumentType={selectedDocumentType}
          setSelectedDocumentType={setSelectedDocumentType}
          documentIds={documentIds}
        />
      </div>
      <div
        className="d-flex flex-column bg-white rounded-4"
        style={{ height: "92%" }}
      >
        {inUseDocumentIds.length === 0 ? (
          <div
            className="d-flex justify-content-center align-items-center bg-custom-dark  shadow p-3 rounded-4"
            style={{ height: "100%" }}
          >
            <h4>{message}</h4>
          </div>
        ) : (
          <>
            <div
              className=" border-4 rounded-2 ms-2 p-2"
              style={{ height: "5%" }}
            >
              <h2>{title}</h2>
            </div>
            <div className="d-flex flex-row bg-white" style={{ height: "94%" }}>
              <div
                className="p-2 flex-grow-1 bg-white rounded-4 overflow-auto shadow border  ms-2"
                id="component_section"
                style={{ maxWidth: "50%", height: "100%" }}
              >
                <EmGptChatBox
                  inUseDocumentIds={inUseDocumentIds}
                  height={getHeight()}
                  setPageNumbers={setPageNumbers}
                  getPageNumber={true}
                  chatSuggestions={chatSuggestions}
                />
              </div>
              <div
                className="p-2 flex-grow-1 bg-white rounded-4  shadow border  ms-2"
                style={{ maxWidth: "50%", height: "100%", overflow: "hidden" }}
              >
                <>
                  <RelevantSection
                    imageUrls={imageUrls}
                    pdfUrl={pdfUrl}
                    pageNumber={pageNumbers}
                  />
                </>
              </div>
            </div>
          </>
        )}
      </div>
    </>
  );
}

export default DocAssistant;
